import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1CategoryList: build.query<
      ApiAdminV1CategoryListApiResponse,
      ApiAdminV1CategoryListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/`,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    apiAdminV1CategoryCreate: build.mutation<
      ApiAdminV1CategoryCreateApiResponse,
      ApiAdminV1CategoryCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/`,
        method: "POST",
        body: queryArg.surveystructureCompliance,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    apiAdminV1CategoryRetrieve: build.query<
      ApiAdminV1CategoryRetrieveApiResponse,
      ApiAdminV1CategoryRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/${queryArg.id}/`,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    apiAdminV1CategoryUpdate: build.mutation<
      ApiAdminV1CategoryUpdateApiResponse,
      ApiAdminV1CategoryUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.surveystructureCompliance,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    apiAdminV1CategoryPartialUpdate: build.mutation<
      ApiAdminV1CategoryPartialUpdateApiResponse,
      ApiAdminV1CategoryPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedSurveystructureCompliance,
        params: {
          status: queryArg.status,
        },
      }),
    }),
    apiAdminV1CategoryDestroy: build.mutation<
      ApiAdminV1CategoryDestroyApiResponse,
      ApiAdminV1CategoryDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/category/${queryArg.id}/`,
        method: "DELETE",
        params: {
          status: queryArg.status,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1CategoryListApiResponse =
  /** status 200  */ SurveystructureComplianceRead[];
export type ApiAdminV1CategoryListApiArg = {
  /** Filter by status */
  status?: number;
};
export type ApiAdminV1CategoryCreateApiResponse =
  /** status 201  */ SurveystructureComplianceRead;
export type ApiAdminV1CategoryCreateApiArg = {
  /** Filter by status */
  status?: number;
  surveystructureCompliance: SurveystructureCompliance;
};
export type ApiAdminV1CategoryRetrieveApiResponse =
  /** status 200  */ SurveystructureComplianceRead;
export type ApiAdminV1CategoryRetrieveApiArg = {
  /** A unique integer value identifying this surveystructure compliance. */
  id: number;
  /** Filter by status */
  status?: number;
};
export type ApiAdminV1CategoryUpdateApiResponse =
  /** status 200  */ SurveystructureComplianceRead;
export type ApiAdminV1CategoryUpdateApiArg = {
  /** A unique integer value identifying this surveystructure compliance. */
  id: number;
  /** Filter by status */
  status?: number;
  surveystructureCompliance: SurveystructureCompliance;
};
export type ApiAdminV1CategoryPartialUpdateApiResponse =
  /** status 200  */ SurveystructureComplianceRead;
export type ApiAdminV1CategoryPartialUpdateApiArg = {
  /** A unique integer value identifying this surveystructure compliance. */
  id: number;
  /** Filter by status */
  status?: number;
  patchedSurveystructureCompliance: PatchedSurveystructureCompliance;
};
export type ApiAdminV1CategoryDestroyApiResponse = unknown;
export type ApiAdminV1CategoryDestroyApiArg = {
  /** A unique integer value identifying this surveystructure compliance. */
  id: number;
  /** Filter by status */
  status?: number;
};
export type PriorityEnum = 1 | 2 | 3;
export type SurveystructureComplianceStatusEnum = 1 | 2;
export type SurveystructureCompliance = {
  name?: string | null;
  priority?: PriorityEnum;
  status?: SurveystructureComplianceStatusEnum;
  categories?: any | null;
  organization?: number | null;
  default_prompt?: string | null;
  default_visibility?: string | null;
  default_question?: string | null;
};
export type SurveystructureComplianceRead = {
  id: number;
  name?: string | null;
  priority?: PriorityEnum;
  status?: SurveystructureComplianceStatusEnum;
  categories?: any | null;
  organization?: number | null;
  created_by: string;
  created_at: string;
  updated_at: string;
  default_prompt?: string | null;
  default_visibility?: string | null;
  default_question?: string | null;
};
export type PatchedSurveystructureCompliance = {
  name?: string | null;
  priority?: PriorityEnum;
  status?: SurveystructureComplianceStatusEnum;
  categories?: any | null;
  organization?: number | null;
  default_prompt?: string | null;
  default_visibility?: string | null;
  default_question?: string | null;
};
export type PatchedSurveystructureComplianceRead = {
  id?: number;
  name?: string | null;
  priority?: PriorityEnum;
  status?: SurveystructureComplianceStatusEnum;
  categories?: any | null;
  organization?: number | null;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
  default_prompt?: string | null;
  default_visibility?: string | null;
  default_question?: string | null;
};
export const {
  useApiAdminV1CategoryListQuery,
  useApiAdminV1CategoryCreateMutation,
  useApiAdminV1CategoryRetrieveQuery,
  useApiAdminV1CategoryUpdateMutation,
  useApiAdminV1CategoryPartialUpdateMutation,
  useApiAdminV1CategoryDestroyMutation,
} = injectedRtkApi;
